<template>
  <div id="navbar_sub">
    <!-- Created By CodingNepal - www.codingnepalweb.com -->
    <nav :style="[this.$store.state.ban ? { top: '145px' } : { top: '75px' }]">
      <div class="wrapper">
        <div class="logo">
          <!-- <a href="">
              <img
                style="width: 40px; height: 40px;margin-top:.25em"
                src="../../assets/photo/2.jpg"
                alt=""
              />
            </a> -->
        </div>
        <input type="radio" name="slider" id="menu-btn" />
        <input type="radio" name="slider" id="close-btn" checked />
        <div @click="black" class="black"></div>

        <ul
          :style="[this.$store.state.ban ? { top: '81px' } : { top: '11px' }]"
          class="nav-links"
        >
          <label for="close-btn" class="btn close-btn">
            <font-awesome-icon icon="times-circle"
          /></label>
          <div class="logo_mobile">فروشگاه اینترنتی</div>
          <li>
            <a href="#" class="desktop-item first"
              ><font-awesome-icon icon="bars" /> &nbsp; دسته بندی کالاها</a
            >
            <input type="checkbox" id="showMega" />
            <label for="showMega" class="mobile-item"
              ><font-awesome-icon icon="bars" /> &nbsp; دسته بندی</label
            >
            <div class="mega-box">
              <div class="content">
                <!-- <div class="row">
                  <img
                    style="height: 250px"
                    src="../../assets/photo/1.jpg"
                    alt="شمع"
                  />
                </div> -->
                <div
                  class="row"
                  :key="(item, index)"
                  v-for="(item, index) in list"
                >
                  <router-link
                    :to="{ name: 'list', params: { id: item.slug } }"
                    class="header"
                  >
                    <font-awesome-icon icon="fire" /> &nbsp; {{ item.name }}
                  </router-link>
                  <ul
                    class="mega-links"
                    :key="(item, index)"
                    v-for="(item, index) in item.children"
                  >
                    <li>
                      <router-link
                        :to="{
                          name: 'list',
                          params: { id: item.slug }
                        }"
                        v-if="item.children.length != 0"
                        ><span class="lvl2">{{ item.name }}</span></router-link
                      >

                      <router-link
                        :to="{
                          name: 'list',
                          params: { id: item.slug }
                        }"
                        href="#"
                        v-else
                        ><span>{{ item.name }}</span></router-link
                      >
                      <ul>
                        <li>
                          <router-link
                            to="/video/list"
                            v-if="item.name == 'فلش آموزشی'"
                            ><span class="added">
                              ویدیوهای آموزشی
                            </span></router-link
                          >
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <router-link
                            to="/download"
                            v-if="item.name == 'فلش آموزشی'"
                            ><span class="added">
                              کتاب های آموزشی
                            </span></router-link
                          >
                        </li>
                      </ul>
                      <ul
                        class="mega-links"
                        :key="(item, index)"
                        v-for="(item, index) in item.children"
                      >
                        <li>
                          <router-link
                            :to="{
                              name: 'list',
                              params: { id: item.slug }
                            }"
                            >{{ item.name }}</router-link
                          >
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!-- <ul>
                    <li>
                      <router-link
                        to="/video/list"
                        v-if="item.name == 'ابزار شمع سازی'"
                        ><span class="added">
                          ویدیوهای آموزشی
                        </span></router-link
                      >
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <router-link
                        to="/download"
                        v-if="item.name == 'ابزار شمع سازی'"
                        ><span class="added">
                          کتاب های آموزشی
                        </span></router-link
                      >
                    </li>
                  </ul> -->
                </div>
              </div>
            </div>
          </li>
          <router-link to="/services" tag="li" active-class="active-nav">
            <a href=""><font-awesome-icon icon="users" /> &nbsp; خدمات ما</a>
          </router-link>
          <router-link to="/special-sale" tag="li" active-class="active-nav">
            <a href=""><font-awesome-icon icon="users" /> &nbsp; فروش ویژه</a>
          </router-link>
          <!-- <router-link to="/video/detail" tag="li" active-class="active-nav">
            <a href=""><font-awesome-icon icon="users" /> &nbsp; ویدیو</a>
          </router-link> -->

          <li>
            <a href="http://suncandle.blogfa.com/" target="_blank"
              ><font-awesome-icon icon="users" /> &nbsp; وبلاگ</a
            >
          </li>
          <router-link to="/about" tag="li" active-class="active-nav">
            <a href=""><font-awesome-icon icon="users" /> &nbsp; درباره ما</a>
          </router-link>

          <!-- <router-link to="/complaints" tag="li" active-class="active-nav">
            <a href=""><font-awesome-icon icon="users" /> &nbsp; انتقادات و پیشنهادات</a>
          </router-link> -->
          <router-link to="/rules" tag="li" active-class="active-nav">
            <a href=""
              ><font-awesome-icon icon="users" /> &nbsp; قوانین و مقررات</a
            >
          </router-link>
          <li></li>
          <router-link to="/contact-us" tag="li" active-class="active-nav">
            <a href=""><font-awesome-icon icon="users" /> &nbsp; تماس با ما</a>
          </router-link>
          <router-link to="/questions" tag="li" active-class="active-nav">
            <a href=""
              ><font-awesome-icon icon="users" /> &nbsp; سوالات متداول</a
            >
          </router-link>
        </ul>
        <label for="menu-btn" class="btn menu-btn">
          منو
          <font-awesome-icon icon="bars" />
        </label>
      </div>
    </nav>

    <!-- <div class="body-text">
        <div class="title">Responsive Dropdown and Mega Menu</div>
        <div class="sub-title">using only HTML & CSS</div>
      </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      sum: this.$store.state.ban
    };
  },
  watch: {
    $route(to, from) {
      $("#close-btn").prop("checked", true);
    }
  },
  created() {
    var that = this;
    $.ajax({
      url: that.$store.state.url + "api/v1/products/cat-list/",
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
      type: "GET",
      success: function(data, textStatus, request) {
        that.list = data;
      },
      error: function(request, textStatus, errorThrown) {
        if (request.state == 500) {
          that.$toastr.e("خطایی در سرور به وجود امده");
          that.$store.state.e500 = true;
        } else {
          that.$store.state.e404 = true;
          that.$toastr.e("خطا در برقراری ارتباط");
        }
      },
      complete: function() {}
    });
  },
  methods: {
    black() {
      // console.log("close");
      $("#close-btn").prop("checked", true);
    }
  },
  mounted() {
    var that = this;
    var sum;

    $.ajax({
      url: that.$store.state.url + "api/v1/pages/top_banner/",
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
      type: "GET",
      success: function(data, textStatus, request) {
        // console.log(data.length, "bo0000000000000000000000000000om");
        if (data.length == 0) {
          that.$store.state.ban = false;
          sum = false;
        } else {
          that.$store.state.ban = true;
          sum = true;
          that.$store.state.bannerdata = data;
          // console.log(that.list);
        }
        // if (data.cart_count) {
        //   that.$store.state.co = data.cart_count;
        // }
      },
      error: function(request, textStatus, errorThrown) {
        if (request.state == 500) {
          that.$toastr.e("خطایی در سرور به وجود امده");
          that.$store.state.e500 = true;
        } else {
          that.$store.state.e404 = true;
          that.$toastr.e("خطا در برقراری ارتباط");
        }
      },
      complete: function() {}
    });
    // console.log(sum, "ddasdfsfsfsafas");

    // console.log(
    //   this.$store.state.ban,
    //   "ohhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh 43214312"
    // );
    var prevScrollpos = window.pageYOffset;
    if (window.innerWidth >= 970) {
      var sum = this.$store.state.ban;

      // console.log("kard");
      window.onscroll = function() {
        // console.log(sum, "reeeeeeeeeed");

        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
          if (sum == true) {
            document.querySelector("nav").style.top = "145px";
          } else {
            document.querySelector("nav").style.top = "75px";
          }
          // document.querySelector("nav").style.top = "145px";
        } else {
          if (sum == true) {
            document.querySelector("nav").style.top = "85px";
          } else {
            document.querySelector("nav").style.top = "20px";
          }
        }
        prevScrollpos = currentScrollPos;
      };
    }
    $(window).resize(function() {
      // console.log(this.$store.state.ban, "ffffffffffffffff");
      var sum = that.$store.state.ban;

      // console.log(window.innerWidth);
      // console.log(this.$store.state.ban, "reeeeeeeeeed");

      if (window.innerWidth >= 970) {
        // console.log("kard");
        window.onscroll = function() {
          var currentScrollPos = window.pageYOffset;
          if (prevScrollpos > currentScrollPos) {
            if (sum == true) {
              document.querySelector("nav").style.top = "145px";
            } else {
              document.querySelector("nav").style.top = "75px";
            }
            // document.querySelector("nav").style.top = "145px";
          } else {
            if (sum == true) {
              document.querySelector("nav").style.top = "85px";
            } else {
              document.querySelector("nav").style.top = "20px";
            }
          }
          prevScrollpos = currentScrollPos;
        };
      }
    });
  }
};
</script>
<style lang="scss">
// @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700&display=swap");
// * {
//   margin: 0;
//   padding: 0;
//   box-sizing: border-box;
//   font-family: "Poppins", sans-serif;
// }
nav {
  direction: ltr;
  position: fixed;
  // top: 145px;
  z-index: 99;
  width: 100%;
  background: var(--main-color);
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.13);
  transition: top 0.3s;
  // z-index: 500;
  // @media screen and (max-width: 500px) {
  //   position: absolute;
  // }
}
nav .wrapper {
  //   background: red;
  position: relative;
  max-width: 1300px;
  padding: 0px 30px;
  height: 50px;
  // line-height: 70px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.wrapper .logo a {
  color: var(--shrink);
  font-size: 30px;
  font-weight: 600;
  text-decoration: none;
}
.wrapper .nav-links {
  direction: rtl;
  display: inline-flex;
}
.nav-links li {
  list-style: none;
}
.nav-links li a {
  font-family: "yekan";
  color: var(--font-color);
  text-decoration: none;
  font-size: 0.9em;
  font-weight: 500;
  padding: 9px 15px;
  //   border-radius: 5px;
  transition: all 0.3s ease;
}
.nav-links li a:hover {
  color: var(--sub-color);
  // border-bottom: 1px solid var(--sub-color);
}
.nav-links .mobile-item {
  display: none;
}
.nav-links .drop-menu {
  position: absolute;
  background: var(--main-color);
  width: 180px;
  line-height: 45px;
  top: 85px;
  opacity: 0;
  visibility: hidden;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
}
.nav-links li:hover .drop-menu,
.nav-links li:hover .mega-box {
  transition: all 0.3s ease;
  top: 47px;
  opacity: 1;
  visibility: visible;
}
.drop-menu li a {
  width: 100%;
  display: block;
  padding: 0 15px 0 0px;
  font-weight: 400;
  border-radius: 0px;
}
.mega-box {
  position: absolute;
  left: 0;
  width: 100%;
  padding: 0 30px;
  top: 85px;
  opacity: 0;
  visibility: hidden;
}
.mega-box .content {
  background: var(--main-color);
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: stretch;
  // width: 100%;
  // justify-content: space-between;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  height: 450px;
  // overflow-x: hidden;
  // box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  // display: grid;
  // grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  // grid-template-rows: 1fr 1fr;
  // gap: 0px 0px;
  // grid-template-areas:
  //   ". . . . ."
  //   ". . . . .";
}
.mega-box .content .row {
  // background: red;
  width: calc(18% - 0px);
  // width: %;
  // line-height: 25px;
  height: auto;
  // overflow: hidden;
  // overflow-y: visible;
  // scrollbar-width: thin;
  // scrollbar-color: var(--bg-color) var(--main-color);
}
.content .row img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.content .row .header {
  color: var(--shrink);
  font-size: 17px;
  font-weight: 500;
}
.content .row .mega-links {
  margin-left: -40px;
  border-right: 1px solid var(--bg-color);
  //   background: red;
}
.row .mega-links li {
  padding: 0 5px;
}
.row .mega-links li a {
  padding: 0px;
  padding: 0 20px;
  color: var(--font-color);
  font-size: 15px;
  display: block;
  font-family: "yekan";
  @media screen and (max-width: 800px) {
    font-size: 13px;
    padding: 0 10px;
  }
  @media screen and (max-width: 500px) {
    font-size: 10px;
    padding: 0 10px;
  }
}
.row .mega-links li a:hover {
  color: var(--sub-color);
  border: none;
}
.wrapper .btn {
  color: var(--font-color);
  font-size: 20px;
  cursor: pointer;
  display: none;
}
.wrapper .btn.close-btn {
  position: absolute;
  font-size: 2em;
  right: 20px;
  top: 10px;
  color: var(--shrink);
  @media screen and (max-width: 800px) {
    font-size: 1.3em;
    // margin-right: auto;
    left: 10%;
    text-align: left;
    // background: red;
  }
  @media screen and (max-width: 500px) {
    font-size: 1.5em;
    // margin-right: auto;
    left: 10%;
    text-align: left;
    // background: red;
  }
}

@media screen and (max-width: 970px) {
  .mega-box .content {
    background: var(--man-color);
    padding: 25px 20px;
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: auto;
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
    // display: grid;
    // grid-template-columns: 1fr 1fr 1fr 1fr;
    // grid-template-rows: 1fr 1fr;
    // gap: 0px 0px;
    // grid-template-areas:
    //   ". . . ."
    //   ". . . .";
  }
  .logo_mobile {
    display: none;
  }
  .wrapper .btn {
    display: block;
  }
  .wrapper .nav-links {
    position: fixed;
    height: 100vh;
    width: 35%;
    max-width: 350px;
    top: 0;
    right: -100%;
    background: var(--main-color);
    scrollbar-width: thin;
    scrollbar-color: var(--bg-color) var(--main-color);
    display: block;
    padding: 50px 10px;
    line-height: 50px;
    overflow-y: auto;
    box-shadow: 0px 15px 15px rgba(0, 0, 0, 0.164);
    transition: all 0.3s ease;
    @media screen and (max-width: 800px) {
      line-height: 40px;
    }
    @media screen and (max-width: 500px) {
      line-height: 30px;
    }
  }
  /* custom scroll bar */
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    background: #242526;
  }
  ::-webkit-scrollbar-thumb {
    background: #3a3b3c;
  }
  #menu-btn:checked ~ .nav-links {
    right: 0%;
    z-index: 500;
    // background: red;
  }
  #menu-btn:checked ~ .black {
    display: block;
  }
  .black {
    // overflow: hidden;
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.219);
    z-index: 400;
    display: none;
  }
  #menu-btn:checked ~ .btn.menu-btn {
    // display: none;
  }
  #close-btn:checked ~ .btn.menu-btn {
    display: block;
  }
  #menu-btn:checked .logo_mobile {
    display: flex;
    background: red;
  }
  .nav-links {
    margin-top: 4em;
    @media screen and (max-width: 800px) {
      margin-top: 5px;
      margin-top: 4em;
      // background: red !important;
      width: 250px !important;
    }
    @media screen and (max-width: 500px) {
      margin-top: 5px;
      margin-top: 4em;
      // background: red !important;
      width: 200px !important;
    }
  }
  .nav-links li {
    margin: 15px 10px;
    @media screen and (max-width: 800px) {
      margin: 7px;
      padding-right: 0.5em;
    }
    @media screen and (max-width: 500px) {
      margin: 5px;
      padding-right: 0.5em;
    }
  }
  .nav-links li a {
    padding: 0 0px;
    display: block;
    font-size: 20px;
    @media screen and (max-width: 800px) {
      font-size: 15px;
    }
    @media screen and (max-width: 500px) {
      font-size: 10px;
    }
  }
  .nav-links .drop-menu {
    position: static;
    opacity: 1;
    top: 65px;
    visibility: visible;
    padding-left: 20px;
    width: 100%;
    max-height: 0px;
    overflow: hidden;
    box-shadow: none;
    transition: all 0.3s ease;
  }
  #showDrop:checked ~ .drop-menu,
  #showMega:checked ~ .mega-box {
    max-height: 100%;
  }
  .nav-links .desktop-item {
    display: none;
  }
  .nav-links .mobile-item {
    display: block;
    color: var(--font-color);
    font-size: 20px;
    font-weight: 500;
    padding-left: 20px;
    cursor: pointer;
    border-radius: 5px;
    transition: all 0.3s ease;
    border-top: 1px solid var(--bg-color);
    @media screen and (max-width: 800px) {
      font-size: 15px;
    }
    @media screen and (max-width: 500px) {
      font-size: 10px;
    }
  }
  .nav-links .mobile-item:hover {
    // background: #3a3b3c;
    color: var(--sub-color);
  }
  .drop-menu li {
    margin: 0;
  }
  .drop-menu li a {
    border-radius: 5px;
    font-size: 18px;
  }
  .mega-box {
    position: static;
    top: 65px;
    opacity: 1;
    visibility: visible;
    padding: 0 20px;
    max-height: 0px;
    overflow: hidden;
    transition: all 0.3s ease;
  }
  .mega-box .content {
    box-shadow: none;
    flex-direction: column;
    padding: 20px 20px 0 20px;
    @media screen and (max-width: 500px) {
      padding: 0px 0px 0 10px;
    }
  }
  .mega-box .content .row {
    width: 100%;
    margin-bottom: 15px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
  }
  .mega-box .content .row:nth-child(1),
  .mega-box .content .row:nth-child(2) {
    border-top: 0px;
  }
  .content .row .mega-links {
    border-left: 0px;
    padding-left: 15px;
    @media screen and (max-width: 500px) {
      padding-left: 10px;
    }
  }
  .row .mega-links li {
    margin: 0;
    @media screen and (max-width: 500px) {
      // font-size: 0.5em !important;
    }
  }
  .content .row .header {
    font-size: 19px;
    @media screen and (max-width: 500px) {
      font-size: 10px;
    }
  }
  .content .row li {
    // font-size: 19px;
    @media screen and (max-width: 500px) {
      font-size: 10px;
    }
  }
}
nav input {
  display: none;
}

.body-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  padding: 0 30px;
}
.body-text div {
  font-size: 45px;
  font-weight: 600;
}
.first {
  border-left: 1px solid var(--bg-color);
  cursor: auto;
}
.first:hover {
  border-bottom: 1px solid var(--sub-color);
}
.logo_mobile {
  font-family: "lalezar";
  font-size: 2em;
  color: var(--sub-color);
  position: absolute;
  right: 70px;
  top: 10px;
  text-shadow: 0 0 5px orange;
  // border-bottom: 1px solid black;
  display: none;
}
.lvl2 {
  color: orange;
}
.added {
  margin-right: -0.2em;
  // color: orange;
}
// .lvl2::before {
//   content: "*";
// }
.active-nav > a {
  color: var(--sub-color) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/main/t.vue